// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33aB8","col":"styles_col__7Ti_a"};